import { FormattedMessage } from 'react-intl';
import { useEffect } from 'react';
import { setItem } from '@alltrails/local-storage';
import type { User } from '@alltrails/types/User';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import useUser from '@alltrails/context/hooks/useUser';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import GenericUpsellStep from '../UpsellSystem/GenericUpsell/GenericUpsellStep';
import styles from './PostAuthUpsell.module.scss';

type Props = {
  navigateTo: (modalKey: 'checkout' | 'upsell') => void;
  onCloseRequest: () => void;
  onSuccess?: (user: User) => void;
  tierSelected: PurchaseTier;
  setTierSelected: (tier: PurchaseTier) => void;
  upsellTrigger: UpsellTrigger;
};

export default function PostAuthUpsellStep({ navigateTo, onCloseRequest, onSuccess, upsellTrigger, tierSelected, setTierSelected }: Props) {
  const user = useUser();

  useEffect(() => {
    setItem('post-auth-upsell', new Date().getTime());

    // Scroll to top in case the user scrolled down in the previous step.
    const modalScrollContainer = document.querySelector('#modal-scroll-container');
    modalScrollContainer?.scrollTo(0, 0);
  }, []);

  return (
    <GenericUpsellStep
      contentsClassName={styles.contentContainer}
      heading={<FormattedMessage defaultMessage="Elevate your adventure" />}
      promoEligibleHeading={<FormattedMessage defaultMessage="Your first week’s on us" />}
      onCloseRequest={() => {
        if (user) {
          onSuccess?.(user);
        }

        onCloseRequest();
      }}
      tierSelected={tierSelected}
      setTierSelected={setTierSelected}
      navigateTo={navigateTo}
      upsellTrigger={upsellTrigger}
    />
  );
}
